import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { displayMoment, displayNow } from '../../../utils/displayTime';

const Timestamp = ({ timestamp, precise, countryCode }) => {
  let time;
  // Vietnam reads the value and the reference clock in the viewer's browser zone, so the
  // Today/Yesterday and year branches below follow the viewer's own calendar.
  const t = displayMoment(timestamp, countryCode);
  const startYear = displayNow(countryCode).startOf('year');
  const accurateTime = (tMoment, tStart) => {
    const now = displayNow(countryCode);
    const minutes = now.diff(tMoment, 'minutes');
    const hours = now.diff(tMoment, 'hours');
    const days = now.diff(tMoment, 'days');
    if (minutes < 60) {
      return tMoment.startOf('minute').fromNow();
    }
    if (hours <= 12) {
      return tMoment.startOf('hour').fromNow();
    }
    if (days < 2) {
      return tMoment.calendar(now, {
        sameDay: '[Today] hh:mm a',
        lastDay: '[Yesterday] hh:mm a',
        lastWeek: 'DD MMM hh:mm a',
        sameElse: 'DD MMM hh:mm a',
      });
    }
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM hh:mm a');
    }
    return tMoment.format('DD/MM/YY hh:mm a');
  };
  const simpleTime = (tMoment, tStart) => {
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM');
    }
    return tMoment.format('DD MMM YYYY');
  };
  if (precise) {
    time = accurateTime(t, startYear);
  } else {
    time = simpleTime(t, startYear);
  }
  return (
    <span className="timestamp">
      {time}
    </span>
  );
};

Timestamp.propTypes = {
  timestamp: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  precise: PropTypes.bool,
  countryCode: PropTypes.string,
};

// Same reactive company selector as the shared components/Timestamp, so login, company
// switching and logout update a mounted timeline without a reload.
export default connect(state => ({
  countryCode: state.auth && state.auth.company && state.auth.company.countryCode,
}))(Timestamp);



// WEBPACK FOOTER //
// ./src/components/Bookings/LeadActivity/Timestamp.jsx